import { render, staticRenderFns } from "./ProspectStatusChangeButtons.vue?vue&type=template&id=007e2c5c"
import script from "./ProspectStatusChangeButtons.vue?vue&type=script&lang=js"
export * from "./ProspectStatusChangeButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports